import Treatability from './Treatability';

export default Treatability;
